import React, { useEffect, useState, useContext } from 'react'


import {
	truck1,
	truck2,
	truck3,
	truck4,
	truck5,
	truck6,
	truck7,
	chart,
  } from '../../../utils/images/imagepath'

  import {
	avatar1,
	avatar2,
	avatar11,
	avatar17,
	avatar13,
	avatar29,
	avatar30,
  } from '../../../utils/images/imagepath'  


function TruckGridView(props:any) {
	console.log(props);

  return (
    <>
	<div className="row">
						<div className="col-xl-6 col-lg-12 d-flex">
							<div className="card truck-card success-border w-100">
								<div className="card-body">
									<div className="card-header">
										<h4 className="card-title">Garbage Truck <span>( AB06 CD 1234 )</span></h4>
										<ul className="nav">
											<li>
												<p className="active-truck-text">
													<span><i className="far fa-circle-dot"></i></span> Active
												</p>
											</li>
											<li>
												<a href="javascript:void(0);" className="truck-item">
													<i className="fas fa-circle-info"></i>
												</a>
											</li>
										</ul>
									</div>
									<div className="card-middle">
										<div className="truck-widget">
											<div className="truck-thumb-img">
												<img src={truck1} className="img-fluid" alt="Truck"/>
											</div>
											<div className="truck-details">
												<div className="row">
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Vehicle Number</p>
															<h6>452BG2654</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Inspector</p>
															<h6>Christopher Edward</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Overall Checklist</p>
															<h6>Completed</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Checklist</p>
															<ul className="nav datas-list">
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
															</ul>
															<h5>28/<span>30</span></h5>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<div className="truck-footer-content">
											<div className="truck-footer-img">
												<img src={avatar1} alt="Profile"/>
											</div>
											<p><span>Cameron Jacob</span> ABC Company</p>
										</div>
										<div className="truck-footer-btn">
											<a href="javascript:void(0);" className="btn btn-light truck-item">View Details</a>
											<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-6 col-lg-12 d-flex">
							<div className="card truck-card warning-border w-100">
								<div className="card-body">
									<div className="card-header">
										<h4 className="card-title">Box truck <span>( HJ06 CD 1234 )</span></h4>
										<ul className="nav">
											<li>
												<p className="minor-truck-text">
													<span><i className="far fa-circle-dot"></i></span> Minor
												</p>
											</li>
											<li>
												<a href="javascript:void(0);" className="truck-item">
													<i className="fas fa-circle-info"></i>
												</a>
											</li>
										</ul>
									</div>
									<div className="card-middle">
										<div className="truck-widget">
											<div className="truck-thumb-img">
												<img src={truck3} className="img-fluid" alt="Truck"/>
											</div>
											<div className="truck-details">
												<div className="row">
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Vehicle Number</p>
															<h6>452BG2654</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Inspector</p>
															<h6>Dominic</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Overall Checklist</p>
															<h6>Not Completed</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Checklist</p>
															<ul className="nav datas-list">
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-warning"></span>
																</li>
																<li>
																	<span className="check-list-warning"></span>
																</li>
																<li>
																	<span className="check-list-warning"></span>
																</li>
															</ul>
															<h5>19/<span>30</span></h5>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<div className="truck-footer-content">
											<div className="truck-footer-img">
												<img src={avatar2} alt="Profile"/>
											</div>
											<p><span>Frank</span> ABC Company</p>
										</div>
										<div className="truck-footer-btn">
											<a href="javascript:void(0);" className="btn btn-light truck-item">View Details</a>
											<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-6 col-lg-12 d-flex">
							<div className="card truck-card secondary-border w-100">
								<div className="card-body">
									<div className="card-header">
										<h4 className="card-title">Medium Duty Truck <span>( AF06 CD 1234 )</span></h4>
										<ul className="nav">
											<li>
												<p className="blocker-truck-text">
													<span><i className="far fa-circle-dot"></i></span> Risk or Blocker
												</p>
											</li>
											<li>
												<a href="javascript:void(0);" className="truck-item">
													<i className="fas fa-circle-info"></i>
												</a>
											</li>
										</ul>
									</div>
									<div className="card-middle">
										<div className="truck-widget">
											<div className="truck-thumb-img">
												<img src={truck5} className="img-fluid" alt="Truck"/>
											</div>
											<div className="truck-details">
												<div className="row">
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Vehicle Number</p>
															<h6>452BG2654</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Inspector</p>
															<h6>Michael Oliver</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Overall Checklist</p>
															<h6>Completed</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Checklist</p>
															<ul className="nav datas-list">
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-danger"></span>
																</li>
																<li>
																	<span className="check-list-danger"></span>
																</li>
																<li>
																	<span className="check-list-danger"></span>
																</li>
																<li>
																	<span className="check-list-warning"></span>
																</li>
															</ul>
															<h5>30/<span>30</span></h5>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<div className="truck-footer-content">
											<div className="truck-footer-img">
												<img src={avatar11} alt="Profile"/>
											</div>
											<p><span>Frank</span> ABC Company</p>
										</div>
										<div className="truck-footer-btn">
											<a href="javascript:void(0);" className="btn btn-light truck-item">View Details</a>
											<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-6 col-lg-12 d-flex">
							<div className="card truck-card success-border w-100">
								<div className="card-body">
									<div className="card-header">
										<h4 className="card-title">Stake bed truck <span>( CV06 CD 1234 )</span></h4>
										<ul className="nav">
											<li>
												<p className="minor-truck-text">
													<span><i className="far fa-circle-dot"></i></span> Minor
												</p>
											</li>
											<li>
												<a href="javascript:void(0);" className="truck-item">
													<i className="fas fa-circle-info"></i>
												</a>
											</li>
										</ul>
									</div>
									<div className="card-middle">
										<div className="truck-widget">
											<div className="truck-thumb-img">
												<img src={truck7} className="img-fluid" alt="Truck"/>
											</div>
											<div className="truck-details">
												<div className="row">
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Vehicle Number</p>
															<h6>452BG2654</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Inspector</p>
															<h6>Christopher Edward</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Overall Checklist</p>
															<h6>Completed</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Checklist</p>
															<ul className="nav datas-list">
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-warning"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
															</ul>
															<h5>30/<span>30</span></h5>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<div className="truck-footer-content">
											<div className="truck-footer-img">
												<img src={avatar30} alt="Profile"/>
											</div>
											<p><span>Cameron Jacob</span> ABC Company</p>
										</div>
										<div className="truck-footer-btn">
											<a href="javascript:void(0);" className="btn btn-light truck-item">View Details</a>
											<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-6 col-lg-12 d-flex">
							<div className="card truck-card success-border w-100">
								<div className="card-body">
									<div className="card-header">
										<h4 className="card-title">Semi Trailer <span>( AB06 CD 1234 )</span></h4>
										<ul className="nav">
											<li>
												<p className="active-truck-text">
													<span><i className="far fa-circle-dot"></i></span> Active
												</p>
											</li>
											<li>
												<a href="javascript:void(0);" className="truck-item">
													<i className="fas fa-circle-info"></i>
												</a>
											</li>
										</ul>
									</div>
									<div className="card-middle">
										<div className="truck-widget">
											<div className="truck-thumb-img">
												<img src={truck6} className="img-fluid" alt="Truck"/>
											</div>
											<div className="truck-details">
												<div className="row">
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Vehicle Number</p>
															<h6>452BG2654</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Inspector</p>
															<h6>William</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Overall Checklist</p>
															<h6>Completed</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Checklist</p>
															<ul className="nav datas-list">
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
															</ul>
															<h5>30/<span>30</span></h5>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<div className="truck-footer-content">
											<div className="truck-footer-img">
												<img src={avatar29} alt="Profile"/>
											</div>
											<p><span>Sebastian Tim</span> ABC Company</p>
										</div>
										<div className="truck-footer-btn">
											<a href="javascript:void(0);" className="btn btn-light truck-item">View Details</a>
											<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xl-6 col-lg-12 d-flex">
							<div className="card truck-card secondary-border w-100">
								<div className="card-body">
									<div className="card-header">
										<h4 className="card-title">Tipper truck <span>( AB06 CD 1234 )</span></h4>
										<ul className="nav">
											<li>
												<p className="blocker-truck-text">
													<span><i className="far fa-circle-dot"></i></span> Risk or Blocker
												</p>
											</li>
											<li>
												<a href="javascript:void(0);" className="truck-item">
													<i className="fas fa-circle-info"></i>
												</a>
											</li>
										</ul>
									</div>
									<div className="card-middle">
										<div className="truck-widget">
											<div className="truck-thumb-img">
												<img src={truck4} className="img-fluid" alt="Truck"/>
											</div>
											<div className="truck-details">
												<div className="row">
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Vehicle Number</p>
															<h6>452BG2654</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Inspector</p>
															<h6>Black</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Overall Checklist</p>
															<h6>Not Completed</h6>
														</div>
													</div>
													<div className="col-md-6">
														<div className="truck-list-text">
															<p>Checklist</p>
															<ul className="nav datas-list">
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-active"></span>
																</li>
																<li>
																	<span className="check-list-warning"></span>
																</li>
																<li>
																	<span className="check-list-danger"></span>
																</li>
																<li>
																	<span className="check-list-danger"></span>
																</li>
															</ul>
															<h5>28/<span>30</span></h5>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="card-footer">
										<div className="truck-footer-content">
											<div className="truck-footer-img">
												<img src={avatar17} alt="Profile"/>
											</div>
											<p><span>Frank</span> ABC Company</p>
										</div>
										<div className="truck-footer-btn">
											<a href="javascript:void(0);" className="btn btn-light truck-item">View Details</a>
											<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
								<div className="pagination">
									<ul className="nav">
										<li>
											<a href="javascript:void(0);">
												<i className="fas fa-chevron-left"></i>
											</a>
										</li>
										<li>
											<a href="javascript:void(0);" className="active">1</a>
										</li>
										<li>
											<a href="javascript:void(0);">2</a>
										</li>
										<li>
											<a href="javascript:void(0);">3</a>
										</li>
										<li>
											<a href="javascript:void(0);">4</a>
										</li>
										<li>
											<a href="javascript:void(0);">5</a>
										</li>
										<li>
											<a href="javascript:void(0);">
												<i className="fas fa-chevron-right"></i>
											</a>
										</li>
									</ul>
								</div>
							</div>
						</div>

					</div>

					<div className="truck-list-sidebar">
				<div className="card">
					<div className="card-header">
						<h4 className="card-title">Vehicle Details</h4>
						<a href="javascript:void(0);" className="clear-truck-list">
							<i className="fas fa-xmark"></i>
						</a>
					</div>
					<div className="card-body">
						<div className="truck-sidebar-btns">
							<a href="javascript:void(0);" className="btn btn-light">
								<i className="feather-edit"></i> Edit
							</a>
							<a href="javascript:void(0);" className="btn btn-secondary">
								<i className="feather-trash-2"></i> Delete
							</a>
						</div>
						<div className="truck-information">
							<h4>Truck Information</h4>
							<div className="truck-information-grid">
								<div className="row">
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Truck Make / Modal</p>
											<h6>Garbage Truck</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Truck Licence Number</p>
											<h6>452BG2654</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Truck Number</p>
											<h6>AB06 CD 1234</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Register Date</p>
											<h6>01-06-2024 09:30AM</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Inspector</p>
											<h6>Dominic</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Inspection Date</p>
											<h6>04-06-2024 10AM</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="truck-information">
							<h4>Driver/Company Details</h4>
							<div className="truck-information-grid">
								<div className="row">
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Driver Name</p>
											<h6>Cameron Jacob</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Company Name</p>
											<h6>ABC Company</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Phone Number</p>
											<h6>+1 456-7890</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Email Address</p>
											<h6>abc@company.com</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>TIN Number</p>
											<h6>1759013776</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Address</p>
											<h6>132, My Street, Kingston, New York</h6>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="truck-information">
							<h4>Inspection Details</h4>
							<div className="truck-information-grid">
								<div className="row">
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Checklist</p>
											<h6>Completed</h6>
										</div>
									</div>
									<div className="col-md-6">
										<div className="truck-information-content">
											<p>Checklist</p>
											<div className="truck-list-text">
												<ul className="nav datas-list">
													<li>
														<span className="check-list-active"></span>
													</li>
													<li>
														<span className="check-list-active"></span>
													</li>
													<li>
														<span className="check-list-active"></span>
													</li>
													<li>
														<span className="check-list-active"></span>
													</li>
													<li>
														<span className="check-list-active"></span>
													</li>
													<li>
														<span className="check-list-active"></span>
													</li>
												</ul>
												<h5>28/<span>30</span></h5>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="card-footer">
						<a href="javascript:void(0);" className="btn btn-light clear-truck-list">Cancel</a>
						<a href="javascript:void(0);" className="btn btn-primary">Go to Checklist</a>
					</div>
				</div>
			</div>
      
    </>
  )
}
export default TruckGridView
